import * as joint from '@joint/core'

/**
 * C4 Robot shape - robot/automated process icon
 */
export const C4Robot = joint.dia.Element.define(
  'c4.Robot',
  {
    size: { width: 200, height: 220 },
    attrs: {
      body: {
        refX: '15%',
        refY: 60,
        refWidth: '70%',
        refHeight: 'calc(h - 60)',
        rx: 10,
        ry: 10,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      head: {
        refX: '20%',
        refY: 10,
        refWidth: '60%',
        height: 45,
        rx: 8,
        ry: 8,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      antenna: {
        refX: '50%',
        refY: 0,
        width: 4,
        height: 15,
        rx: 2,
        fill: '#2e6295',
        stroke: 'none',
      },
      antennaBall: {
        refX: '50%',
        refY: 0,
        r: 5,
        fill: '#ff5722',
        stroke: 'none',
      },
      eyeLeft: {
        refX: '35%',
        refY: 28,
        r: 8,
        fill: '#ffffff',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      eyeRight: {
        refX: '65%',
        refY: 28,
        r: 8,
        fill: '#ffffff',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      pupilLeft: {
        refX: '35%',
        refY: 28,
        r: 4,
        fill: '#2e6295',
        stroke: 'none',
      },
      pupilRight: {
        refX: '65%',
        refY: 28,
        r: 4,
        fill: '#2e6295',
        stroke: 'none',
      },
      nameLabel: {
        refX: '50%',
        refY: 100,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 120,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Robot]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 145,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '65%',
          height: 60,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'rect', selector: 'body' },
      { tagName: 'rect', selector: 'head' },
      { tagName: 'rect', selector: 'antenna' },
      { tagName: 'circle', selector: 'antennaBall' },
      { tagName: 'circle', selector: 'eyeLeft' },
      { tagName: 'circle', selector: 'eyeRight' },
      { tagName: 'circle', selector: 'pupilLeft' },
      { tagName: 'circle', selector: 'pupilRight' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createRobot(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Robot: ${technology}]` : '[Robot]'

  const robot = new C4Robot({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      head: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      antenna: {
        ...(style?.stroke && { fill: style.stroke }),
      },
      eyeLeft: {
        ...(style?.stroke && { stroke: style.stroke }),
      },
      eyeRight: {
        ...(style?.stroke && { stroke: style.stroke }),
      },
      pupilLeft: {
        ...(style?.stroke && { fill: style.stroke }),
      },
      pupilRight: {
        ...(style?.stroke && { fill: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return robot
}
